// Import: Middleware Action & Custom Types
import {
    CLEAN_CHECK_PAYMENT_STATUS,
    CLEAN_CHECK_PAYMENT_STATUS_ERROR,
} from "_models/redux/types";

// Action function
export const cleanCheckPaymentStatusAction = (params) => async (dispatch) => {
    // Endpoint: Try & Catch
    try {
        dispatch({
            type: CLEAN_CHECK_PAYMENT_STATUS,
            payload: undefined,
        });
    } catch (e) {
        dispatch({
            type: CLEAN_CHECK_PAYMENT_STATUS_ERROR,
            payload: undefined,
        });
    }
};
